import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit, OnChanges, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ProformaIncome } from '../proforma-income';
import { ProformaIncomeService } from '../proforma-income.service';
import { ProformaIncomeComponent } from '../proforma-income/proforma-income.component';

@Component({
	selector: 'app-proforma-income-list',
	templateUrl: './proforma-income-list.component.html',
	styleUrls: ['./proforma-income-list.component.css'],
	providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
	standalone: false,
	// make column heading sticky
	styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`]
})
export class ProformaIncomeListComponent implements OnInit, OnChanges {
	constructor(
		private proformaIncomeService: ProformaIncomeService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = proformaIncomeService.statuses
	}
	// data

	@Input() proformaId: any;
	@Input() updateIncome: boolean = false;
	@Input() isPublicAndPublish: boolean;
	@Input() showFilter = true;
	@Input() showPagination = true;

	@Output() doUpdate = new EventEmitter<any>();
	@Output() getMetaInfo = new EventEmitter<string>();


	proformaIncomes: any;
	proformaIncome: ProformaIncome;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'seasonName', header: 'Season', width: 'auto' },
		{ field: 'seasonStart', header: 'Start', width: 'auto' },
		{ field: 'seasonEnd', header: 'End', width: 'auto' },
		{ field: 'numNights', header: 'Nights', width: 'auto' },
		{ field: 'hightRateAmt', header: 'High $', width: 'auto' },
		{ field: 'highAdjPct', header: 'High %', width: 'auto' },
		{ field: 'targetRateAmt', header: 'Target $', width: 'auto' },
		{ field: 'targetOccupancyPct', header: 'Target %', width: 'auto' },
		{ field: 'lowRateAmt', header: 'Low $', width: 'auto' },
		{ field: 'lowAdjPct', header: 'Low %', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'seasonStart', order: 1 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	ngOnChanges() {
		this.ngOnInit();
	}  
	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.proformaIncomeId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-proformaIncome-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'seasonStart', order: -1 });
			}
			if(this.proformaId)
			{
				// show only proformaIncome that are assigned to this proformaId
				let proformaIdFilter = { 'proformaVO.proformaId': { 'value': this.proformaId, 'matchMode': 'in' } };
				Object.assign(event.filters, proformaIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.proformaIncomeService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.proformaIncomes = res.data.proformaIncomes;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.proformaIncomes = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(proformaIncome: ProformaIncome) {
		try {
			this.formLoading = true;
			this.proformaIncomeService.update(proformaIncome)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.proformaIncomes.map((proformaIncome, i) => {
							if (proformaIncome.proformaIncomeId === res.data.proformaIncome.proformaIncomeId) {
								this.proformaIncomes[i] = res.data.proformaIncome;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(proformaIncome: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(proformaIncome));

			this.formLoading = true;
			this.proformaIncomeService.delete(proformaIncome.proformaIncomeId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.proformaIncomes.splice(this.proformaIncomes.indexOf(proformaIncome), 1);
						this.recordTotal = this.proformaIncomes.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ProformaIncome ' + proformaIncome.proformaIncomeId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'ProformaIncome ' + proformaIncome.proformaIncomeId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add ProformaIncome',
			proformaId: this.proformaId

		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ProformaIncomeComponent, dialogConfig);

		//pass meta info to parent
		dialogRef.componentInstance.getMetaInfo.subscribe((metaInfo: string) => {
			this.getMetaInfo.emit(metaInfo); // bubble up to parent
		});
		
		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addProformaIncomeCB(data);
				this.doUpdate.emit(data);
				this.ngOnInit();
				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(proformaIncome: ProformaIncome) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			proformaIncome: proformaIncome,
			title: 'Edit ProformaIncome'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ProformaIncomeComponent, dialogConfig);

		//pass meta info to parent
		dialogRef.componentInstance.getMetaInfo.subscribe((metaInfo: string) => {
			this.getMetaInfo.emit(metaInfo); // bubble up to parent
		});


		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateProformaIncomeCB(data);
				this.doUpdate.emit(data);
				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteProformaIncomeCB(data);
				this.doUpdate.emit(data);
				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addProformaIncomeCB(proformaIncome: ProformaIncome) {
		console.log('Adding ProformaIncome: ' + JSON.stringify(proformaIncome));
		// if we don't have a proformaIncomes array yet...
		if (!this.proformaIncomes) {
			this.proformaIncomes = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.proformaIncomes.unshift(proformaIncome);

		// no idea what this is but it is required to update the array
		this.proformaIncomes = [...this.proformaIncomes];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ProformaIncome ' + proformaIncome.proformaIncomeId + ' Added', life: 3000 });
	}

	updateProformaIncomeCB(proformaIncome: ProformaIncome) {
		console.log('Updating ProformaIncome: ' + JSON.stringify(proformaIncome));
		let itemIndex = this.proformaIncomes.findIndex((item: any) => item.proformaIncomeId === proformaIncome.proformaIncomeId);
		this.proformaIncomes[itemIndex] = proformaIncome;

		// no idea what this is but it is required to update the array
		this.proformaIncomes = [...this.proformaIncomes];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ProformaIncome ' + proformaIncome.proformaIncomeId + ' Updated', life: 3000 });
	}

	deleteProformaIncomeCB(proformaIncome: ProformaIncome) {
		console.log('Removing ProformaIncome: ' + proformaIncome);
		this.proformaIncomes.splice(this.proformaIncomes.indexOf(proformaIncome), 1);
		this.recordTotal = this.proformaIncomes.length;

		// no idea what this is but it is required to update the array
		this.proformaIncomes = [...this.proformaIncomes];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ProformaIncome ' + proformaIncome.proformaIncomeId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.proformaIncomes ? this.first === (this.proformaIncomes.length - this.rows) : true; }
	isFirstPage(): boolean { return this.proformaIncomes ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(proformaIncome: any) {
		if (proformaIncome?.status) {
			const status = this.statuses.find((e: any) => e.value == proformaIncome.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}
}
